<template lang="pug">
el-collapse#card-dados-territorio-croqui(v-model='collapse')
    el-collapse-item.pb-0(name='item')
        header.p-2(slot='title')
            .esquerda
                span {{ index + 1 }}
                h3 {{ territorio.nome }}
                span.erro(v-if='$v.dados.$invalid') *

            .direita
                h3.mr-2.p-1 {{ territorio.localidade }}
                BaseButton.buttonLaudoDanger(
                    type='danger',
                    icon='el-icon-delete',
                    @click='$emit("removerTerritorio", territorio.id)'
                )

        el-form.form.p-2(label-position='top', size='small')
            el-form-item.produtor
                .label(slot='label')
                    span {{ $t('mensagens.laudos.pessoa') }}
                    span(v-show='this.territorio.representantes.length === 0') - {{ $t('mensagens.laudos.nenhumaPessoaVinculada') }}
                    span.erro(
                        v-if='$v.nomeRepresentante.$invalid && $v.cpfCnpjRepresentante.$invalid'
                    ) *
                el-radio(
                    v-for='(representante, index) in territorio.representantes',
                    v-model='representanteSelecionado',
                    :label='index',
                    :key='representante.cpfCnpj'
                )
                    | {{ representante.nomeRazaoSocial }} ({{ numeralStringFormatTocpfCnpj(representante.cpfCnpj) }})
                    span.espacoRepresentante

                .outro
                    el-radio(
                        v-model='representanteSelecionado',
                        :label='outroRepresentante'
                    ) {{ $t('mensagens.laudos.outro') }}:
                    .input(
                        v-if='representanteSelecionado == outroRepresentante'
                    )
                        el-input.nome(
                            v-model='outro.nome',
                            :placeholder="$t('mensagens.laudos.insiraNomeOuRazaoSocialDaPessoa')"
                        )

                        el-input.cpfCnpj(
                            v-model='outro.cpfCnpj',
                            :placeholder="$t('mensagens.laudos.documentoDaPessoa')",
                            :class='{ "erro-borda": !cpfCnpjValido }',
                            @change='aplicarMascara()'
                        )

                    .input(v-else)
                        el-input.nome(
                            disabled,
                            :placeholder="$t('mensagens.laudos.insiraNomeOuRazaoSocialDaPessoa')"
                        )
                        el-input.cpfCnpj(
                            disabled,
                            :placeholder="$t('mensagens.laudos.documentoDaPessoa')",
                        )

            el-form-item(:label="$t('mensagens.laudos.proprietarioS')")
                el-select.w-100(
                    v-model='proprietariosSelecionados',
                    multiple,
                    :placeholder="$t('mensagens.comuns.selecione')",
                    filterable,
                    remote,
                    reserve-keyword,
                    :remote-method='remoteMethod',
                    @change='handleChangeSelectInput($event)',
                    value-key='id',
                    ref='elselectinput',
                    collapse-tags
                )
                    el-option(
                        v-for='representante in representantesProp',
                        :key='representante.cpfCnpjRepresentante',
                        :value='representante',
                        :label='representante.nomeRazaoSocial'
                    ) {{ representante.nomeRazaoSocial }}
                    div(
                        style='display: flex; justify-content: space-between; padding: 5px'
                    )
                        el-input(
                            v-model='proprietario.nome',
                            :placeholder="$t('mensagens.laudos.insiraNomeOuRazaoSocialDaPessoa')",
                            style='width: 70%; padding-right: 5px'
                        )

                        el-input(
                            v-model='proprietario.cpfCnpj',
                            :placeholder="$t('mensagens.laudos.documentoDaPessoa')",
                            :class='{ "erro-borda": !cpfCnpjValido }',
                            @change='aplicarMascaraProprietario()',
                            style='width: 30%; padding-right: 5px'
                        )

                        BaseButton(
                            size='small',
                            type='primary',
                            icon='el-icon-plus',
                            @click='adicionarProprietario'
                        )
                            | {{ $t('mensagens.comuns.adicionar') }}

            .dados.proprietarios-selecionados
                .proprietarios-selecionados__titulo {{ $t('mensagens.laudos.pessoasSelecionadas') }}:
                    el-tag.proprietarios-selecionados__tag.mx-1(
                        v-for='(tag, index) in proprietariosSelecionados',
                        :key='index',
                        @close='removerTag(tag)',
                        closable,
                        type='info',
                        effect='light',
                        round
                    )
                        span {{ tag.nomeRazaoSocial }}

            .dados
                el-form-item
                    .label(slot='label')
                        span {{ $t('mensagens.laudos.matricula') }}
                    el-input(v-model='matricula', @change='emitirDados')

                el-form-item
                    .label(slot='label')
                        span CPR
                    el-input(v-model='cpr', @change='emitirDados')

                el-form-item
                    .label(slot='label')
                        span {{ $t('mensagens.laudos.areaDePenhor') }}
                    el-input(
                        v-model='areaPenhorha',
                        type='number',
                        @change='emitirDados'
                    )

                el-form-item
                    .label(slot='label')
                        span {{ $t('mensagens.laudos.numeroDeEmitentes') }}&nbsp;
                        span.erro(v-if='$v.numeroEmitentes.$invalid') *
                    el-input-number(
                        v-model='numeroEmitentes',
                        :min='0',
                        step-strictly,
                        @change='emitirDados'
                    )

                el-form-item
                    .label(slot='label', style='width: 266px')
                        span {{ $t('mensagens.laudos.formatoExibicaoDasCoordenadas') }}&nbsp;
                        span.erro(v-if='$v.formatoCoordenadas.$invalid') *
                    el-radio-group(
                        v-model='formatoCoordenadas',
                        @change='emitirDados'
                    )
                        el-radio-button(label='DECIMAL') {{ $t('mensagens.laudos.decimal') }}
                        el-radio-button(label='GMS') GMS
</template>

<script>
import formatters from '@/utils/formatters';
import validators from '@/utils/validators';
import { required, minValue } from 'vuelidate/lib/validators';
import TipoLaudo from '@/constants/TipoLaudo';
import RepresentanteService from '@/services/RepresentanteService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

const OUTRO_REPRESENTANTE = '42';

export default {
    name: 'CardDadosTerritorioCroqui',
    components: {
        BaseButton
    },
    emits: ['removerTerritorio', 'getDados', 'getValidacao'],

    props: {
        territorio: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            default: 0
        },
        valido: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            collapse: ['item'],
            representanteSelecionado: '',
            outro: {
                nome: '',
                cpfCnpj: ''
            },
            outroRepresentante: OUTRO_REPRESENTANTE,
            nomeRepresentante: '',
            cpfCnpjRepresentante: '',
            areaPenhorha: null,
            numeroEmitentes: null,
            matricula: null,
            cpr: null,
            tipoLaudoId: '',
            cpfCnpjValido: true,
            proprietario: {
                nome: null,
                cpfCnpj: null
            },
            proprietariosSelecionados: [],
            representantesProp: [],
            paginacao: {
                paginaAtual: 1,
                tamanhoPagina: 5
            },
            formatoCoordenadas: null
        };
    },

    async mounted() {
        await this.buscarRepresentantesEmpresa();

        if (this.territorio.representantes.length === 0) {
            this.representanteSelecionado = OUTRO_REPRESENTANTE;
        } else {
            this.representantesProp = [...this.territorio.representantes];
        }

        this.$emit('getValidacao', {
            valido: !this.$v.dados.$invalid,
            id: this.territorio.id
        });
    },

    watch: {
        representanteSelecionado: function () {
            if (this.representanteSelecionado !== OUTRO_REPRESENTANTE) {
                this.nomeRepresentante =
                    this.territorio.representantes[
                        this.representanteSelecionado
                    ].nomeRazaoSocial;
                this.cpfCnpjRepresentante =
                    this.territorio.representantes[
                        this.representanteSelecionado
                    ].cpfCnpj;
            } else {
                this.nomeRepresentante = '';
                this.cpfCnpjRepresentante = '';
            }
        },

        'outro.nome': function () {
            this.nomeRepresentante = this.outro.nome;
        },

        'outro.cpfCnpj': function () {
            this.cpfCnpjValido = validators.validarDocumento(this.outro.cpfCnpj);

            if (this.cpfCnpjValido) {
                this.cpfCnpjRepresentante = this.outro.cpfCnpj;
            } else {
                this.cpfCnpjRepresentante = '';
            }
        },
        '$v.dados.$invalid': function () {
            this.emitirDados();
        }
    },

    validations: {
        numeroEmitentes: { required, minValue: minValue(1) },
        nomeRepresentante: { required },
        cpfCnpjRepresentante: { required },
        formatoCoordenadas: { required },

        dados: [
            'numeroEmitentes',
            'nomeRepresentante',
            'cpfCnpjRepresentante',
            'formatoCoordenadas'
        ]
    },

    methods: {
        getFiltros(query) {
            const filtro = {};
            filtro.page = this.paginacao.paginaAtual - 1;
            filtro.size = this.paginacao.tamanhoPagina;
            filtro.searchText = query || '';
            if (validators.validarCPF(query)) {
                filtro.searchText = formatters.documentoFormatToNumeral(query);
            }
            filtro.order = '&sort=nome_razao_social,asc';
            return filtro;
        },

        async buscarRepresentantesEmpresa(query) {
            try {
                const { data } = await RepresentanteService.findAllByFiltro(
                    this.getFiltros(query)
                );
                this.representantesProp = data.resultados;
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.laudos.erro.naoFoiPossivelCarregarOsDadosDasPessoas')
                });
            }
        },

        numeralStringFormatTocpfCnpj(value) {
            return formatters.numeralStringFormatToDocumento(value);
        },

        cpfCnpjFormatToNumeral(value) {
            return formatters.documentoFormatToNumeral(value);
        },
        emitirDados() {
            if (!this.$v.dados.$invalid) {
                this.$emit('getValidacao', {
                    valido: true,
                    id: this.territorio.id
                });
                let proprietarios = [];

                if (this.proprietariosSelecionados) {
                    this.proprietariosSelecionados.forEach(prop => {
                        if (prop.id > 0) {
                            let proprietario = {
                                nomeProprietario: prop.nomeRazaoSocial,
                                documentoProprietario: prop.cpfCnpj,
                                tipoDocumentoProprietario: prop.cpfCnpj.length < 11 ? 'RUC' : 'CPF_CNPJ'
                            };
                            proprietarios.push(proprietario);
                        }
                    });
                }

                const matriculas = [...Array(this.matricula)];
                this.$emit('getDados', {
                    dados: {
                        areaPenhor:
                            this.areaPenhorha != null
                                ? this.areaPenhorha.replace(',', '.')
                                : null,
                        matriculas: matriculas,
                        cpr: this.cpr,
                        qdeEmitentes: this.numeroEmitentes,
                        nomeRepresentante: this.nomeRepresentante,
                        cpfCnpjRepresentante: this.cpfCnpjFormatToNumeral(
                            this.cpfCnpjRepresentante
                        ),
                        tipoDocumentoRepresentante: this.cpfCnpjRepresentante.length < 11 ? 'RUC' : 'CPF_CNPJ',
                        territorioId: this.territorio.id,
                        tipoLaudoId: TipoLaudo.CROQUI,
                        formatoCoordenadas: this.formatoCoordenadas,
                        proprietarios: proprietarios
                    },
                    id: this.territorio.id
                });
            } else {
                this.$emit('getValidacao', {
                    valido: false,
                    id: this.territorio.id
                });
            }
        },

        adicionarProprietario() {
            if (!this.proprietario.nome || !this.proprietario.cpfCnpj) {
                this.$notify.error({
                    message: this.$t('mensagens.laudos.insiraNomeDocumentoDaPessoaParaIncluir')
                });
                return;
            }

            let rep = {
                nomeRazaoSocial: this.proprietario.nome,
                cpfCnpj: this.cpfCnpjFormatToNumeral(this.proprietario.cpfCnpj),
                id: Math.floor(Math.random() * 100000000)
            };

            this.proprietariosSelecionados.push(rep);
            this.representantesProp.push(rep);

            this.proprietario = {
                nome: null,
                cpfCnpj: null
            };
        },

        remoteMethod(query) {
            this.buscarRepresentantesEmpresa(query);
        },

        handleChangeSelectInput() {
            this.$nextTick(() => {
                this.$refs.elselectinput.query = '';
            });
        },
        removerTag(tag) {
            this.proprietariosSelecionados.splice(
                this.proprietariosSelecionados.indexOf(tag),
                1
            );
        },

        aplicarMascara() {
            this.outro.cpfCnpj = formatters.documentoFormatToNumeral(this.outro.cpfCnpj);
            this.outro.cpfCnpj = formatters.numeralStringFormatToDocumento(this.outro.cpfCnpj);
        },

        aplicarMascaraProprietario() {
            this.proprietario.cpfCnpj = formatters.documentoFormatToNumeral(this.proprietario.cpfCnpj);
            this.proprietario.cpfCnpj = formatters.numeralStringFormatToDocumento(this.proprietario.cpfCnpj);
        }
    }
};
</script>

<style lang="scss" scoped>
#card-dados-territorio-croqui {
    background-color: var(--white);
    border-radius: 4px;
    overflow: hidden;

    header {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0 !important;

        .esquerda,
        .direita {
            display: flex;
            align-items: center;
            justify-content: space-between;

            gap: 4px;
        }

        .esquerda {
            span {
                color: var(--gray);
                font-size: 12px;
            }
        }

        .direita {
            h3 {
                background-color: var(--default-border-color);
                border-radius: 4px;
            }
        }
    }

    .form {
        .produtor .outro .input {
            display: flex;
            justify-content: space-between;

            .nome {
                width: 66%;
            }

            .cpfCnpj {
                width: 33%;
            }
        }

        .dados {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            gap: 8px;
            width: 100% !important;

            .el-input,
            .el-select,
            .el-date-picker {
                width: 150px;
            }
        }
        .proprietarios-selecionados {
            flex-wrap: wrap;

            .proprietarios-selecionados__titulo {
                font-size: 14px;
                color: var(--text-disabled);
            }

            .proprietarios-selecionados__tag {
                margin: 0px 5px 10px 5px;
                height: 25px !important;
                line-height: 25px !important;
                border-radius: 10px !important;
                .el-icon-close {
                    color: var(--secondary-font-color);
                    background-color: var(--disabled-font-color);
                }
                .el-icon-close:hover {
                    color: var(--white);
                    background-color: var(--secondary-font-color);
                }
            }
        }

        .el-radio {
            min-width: 0px !important;
        }
    }

    .el-input-number.el-input-number--small {
        width: 152px !important;
    }
}

.el-collapse-item__arrow {
    width: 0px;
    color: var(--white);
}

.el-form-item__label {
    margin-bottom: -10px;
}

.el-collapse-item__content {
    padding-bottom: 0px;
}

.erro {
    color: red !important;
}

.erro-borda {
    border-radius: 4px;
    border: 1px solid red;
}
</style>
